import { render, staticRenderFns } from "./UserSetRole.vue?vue&type=template&id=01709341&scoped=true"
import script from "./UserSetRole.vue?vue&type=script&lang=js"
export * from "./UserSetRole.vue?vue&type=script&lang=js"
import style0 from "./UserSetRole.vue?vue&type=style&index=0&id=01709341&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01709341",
  null
  
)

export default component.exports